import uuid from "react-uuid";
import { compose } from "redux";
import { getRadiusAttributeValue } from "../../constants";
import { globalChartColor } from "../../constants/enums";
import { DEFAULT_CHART_SETTINGS } from "../../constants/enums";
import { setDataSource } from "./WidgetLibrary";

export const setRichFields = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_RICH_FIELDS",
      widgetGraphConfig: value,
    });
  };
};

export const setRichFieldsContent = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_RICH_FIELDS_CONTENT",
      widgetGraphConfig: value,
    });
  };
};

export const set_DataSource = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DATASOURCE",
      widgetGraphConfig: value,
    });
  };
};
export const setX_attribute = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_X_ATTRIBUTE",
      widgetGraphConfig: value,
    });
  };
};
export const setY_attribute = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_Y_ATTRIBUTE",
      widgetGraphConfig: value,
    });
  };
};
export const setFilterObj = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.postcard_pills_filter = null;
  updateWidgetGraphConfig.filter_by_data = null;
  updateWidgetGraphConfig.deep_dive_on = null;
  if (updateWidgetGraphConfig?.order_by?.attribute) {
    updateWidgetGraphConfig.order_by = {
      ...updateWidgetGraphConfig.order_by,
      offset: 0,
    };
  }
  updateWidgetGraphConfig.filters = value;
  return (dispatch) => {
    dispatch({
      type: "SET_FILTER_OBJ",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setFilterByDropdownAttributes = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FILTER_BY_DROPDOWN",
      widgetGraphConfig: value,
    });
  };
};
export const setWidgetMakerDuration = (
  value,
  obj,
  x_axis_data,
  breakdown_by_data = []
) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.duration = value;
  updateWidgetGraphConfig.x_axis = x_axis_data ? x_axis_data : obj?.x_axis;
  updateWidgetGraphConfig.breakdown_by = breakdown_by_data?.length
    ? breakdown_by_data
    : obj?.breakdown_by;
  updateWidgetGraphConfig.filter_by_data = null;
  updateWidgetGraphConfig.postcard_pills_filter = null;
  updateWidgetGraphConfig.deep_dive_on = null;
  if (updateWidgetGraphConfig?.order_by?.attribute) {
    updateWidgetGraphConfig.order_by = {
      ...updateWidgetGraphConfig?.order_by,
      offset: 0,
    };
  }
  if (updateWidgetGraphConfig?.filter_by_dropdown) {
    updateWidgetGraphConfig.filter_by_dropdown = null;
  }
  if (updateWidgetGraphConfig?.filter_by_dropdown_data) {
    updateWidgetGraphConfig.filter_by_dropdown_data = null;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_DURATION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetBrands = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.brands = value;
  updateWidgetGraphConfig.filter_by_data = null;
  updateWidgetGraphConfig.postcard_pills_filter = null;
  updateWidgetGraphConfig.deep_dive_on = null;
  if (updateWidgetGraphConfig?.filter_by_dropdown) {
    updateWidgetGraphConfig.filter_by_dropdown = null;
  }
  if (updateWidgetGraphConfig?.filter_by_dropdown_data) {
    updateWidgetGraphConfig.filter_by_dropdown_data = null;
  }

  if (updateWidgetGraphConfig?.order_by?.attribute) {
    updateWidgetGraphConfig.order_by = {
      ...updateWidgetGraphConfig?.order_by,
      offset: 0,
    };
  }

  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_BRANDS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetChartType = (
  value,
  obj,
  brands,
  graphConditions,
  workspace_privileges
) => {
  let updateWidgetGraphConfig = { ...obj };
  // updateWidgetGraphConfig.chart_attributes_field_config = {
  //   selected_field: null,
  //   data: [],
  //   open_chart_setting_flag: false,
  //   selected_chart_type: null,
  // };
  if (updateWidgetGraphConfig?.data_source) {
    updateWidgetGraphConfig.data_source = null;
  }
  if (
    value !== "heatmap" &&
    updateWidgetGraphConfig?.x_axis?.attribute ===
      updateWidgetGraphConfig?.breakdown_by?.[0]?.attribute
  ) {
    updateWidgetGraphConfig.x_axis = null;
    updateWidgetGraphConfig.breakdown_by = null;
  }

  updateWidgetGraphConfig.chart_type = value;
  updateWidgetGraphConfig.rich_fields_content = null;

  if (updateWidgetGraphConfig.edit_fields) {
    updateWidgetGraphConfig.edit_fields.boolValue = false;
  }
  updateWidgetGraphConfig.dragDataType.datetime = false;
  updateWidgetGraphConfig.dragDataType.int = false;
  updateWidgetGraphConfig.dragDataType.varchar = false;
  updateWidgetGraphConfig.dragDataType.json = false;

  let arr = [];
  arr = Object.keys(updateWidgetGraphConfig?.y_axis).map(
    (key) => updateWidgetGraphConfig?.y_axis[key]
  );

  let updated = arr?.map((d) => {
    if (d?.percent) {
      d.percent = false;
    }
    return d;
  });

  let finalUpdateYseries = {};
  Object.entries(updated).forEach((e, i) => {
    finalUpdateYseries = {
      ...finalUpdateYseries,
      [`y_series_${i + 1}`]: { ...e[1] },
    };
  });

  if (value === "combination") {
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (updateWidgetGraphConfig.x_axis) {
      updateWidgetGraphConfig.x_axis.x_limit = 30;
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null;
    updateWidgetGraphConfig.chart_settings.is_stacked_disabled = false;
    if (
      finalUpdateYseries?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
        y_series_2: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else {
      if (
        updateWidgetGraphConfig?.brands &&
        updateWidgetGraphConfig?.brands?.length &&
        updateWidgetGraphConfig?.brands?.[0].competitor
      ) {
        updateWidgetGraphConfig.chart_settings.benchmark_line = false;
        updateWidgetGraphConfig.chart_settings.group_line_agg = null;
        updateWidgetGraphConfig.chart_settings.benchmark_static_value = null;
      }
      if (!updateWidgetGraphConfig.breakdown_by?.length) {
        updateWidgetGraphConfig.chart_settings.is_stacked = false;
        updateWidgetGraphConfig.chart_settings.gradient_color = true;
      } else if (!updateWidgetGraphConfig?.chart_settings?.is_stacked) {
        updateWidgetGraphConfig.chart_settings.gradient_color = true;
      }
      if (updateWidgetGraphConfig.breakdown_by?.length > 1) {
        while (updateWidgetGraphConfig?.breakdown_by?.length > 1) {
          updateWidgetGraphConfig.breakdown_by.pop();
        }
        updateWidgetGraphConfig.breakdown_by.map((d) => {
          d.is_pivot = false;
          if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
            d.date_part = d?.date_part
              ? ["ww", "mm", "qq"]?.includes(d?.date_part)
                ? d?.date_part
                : "ww"
              : "ww";
            if (d?.date_aggregation) delete d?.date_aggregation;
          }
        });
      }

      updateWidgetGraphConfig.x_axis = updateWidgetGraphConfig.x_axis;
      // to check and updated date_part value of breakdown_by
      if (
        updateWidgetGraphConfig?.breakdown_by &&
        updateWidgetGraphConfig?.breakdown_by?.length
      ) {
        updateWidgetGraphConfig.breakdown_by =
          updateWidgetGraphConfig?.breakdown_by?.map((d) => {
            if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
              d.date_part = d?.date_part
                ? ["ww", "mm", "qq"]?.includes(d?.date_part)
                  ? d?.date_part
                  : "ww"
                : "ww";
              if (d?.date_aggregation) delete d?.date_aggregation;
            }
            return d;
          });
      }
      updateWidgetGraphConfig.breakdown_by =
        updateWidgetGraphConfig.breakdown_by;

      if (Object.keys(finalUpdateYseries)?.length > 0) {
        let arr = [];
        arr = Object.keys(finalUpdateYseries).map(
          (key) => finalUpdateYseries[key]
        );
        let filteredArray = arr?.filter((d) => d.attribute);

        if (filteredArray?.length == 1) {
          let yseriesObject = {};
          let y_axis_settings_array = [];
          Object.entries(filteredArray).forEach((e, i) => {
            if (e?.[1]?.info_text) {
              delete e?.[1]?.info_text;
            }
            if (e?.[1]?.variable_size) {
              delete e?.[1]?.variable_size;
            }
            yseriesObject = {
              ...yseriesObject,
              [`y_series_${i + 1}`]: { ...e[1] },
              y_series_2: {
                attribute: null,
                aggregation: "COUNT",
              },
            };
            y_axis_settings_array = [
              ...y_axis_settings_array,
              {
                show_as: i === 0 ? "bar" : "line",
                y_axis_map_at: i === 0 ? 0 : 1,
                y_axis_scale: "linear",
                color_pattern_code: 1,
                key: uuid(),
              },
            ];
          });

          updateWidgetGraphConfig.y_axis_settings = y_axis_settings_array;
          updateWidgetGraphConfig.y_axis = yseriesObject;
        } else if (filteredArray?.length > 0) {
          let yseriesObject = {};
          let y_axis_settings_array = [];

          Object.entries(filteredArray).forEach((e, i) => {
            if (i < 10) {
              if (e?.[1]?.info_text) {
                delete e?.[1]?.info_text;
              }
              if (e?.[1]?.variable_size) {
                delete e?.[1]?.variable_size;
              }
              yseriesObject = {
                ...yseriesObject,
                [`y_series_${i + 1}`]: { ...e[1] },
              };
              y_axis_settings_array = [
                ...y_axis_settings_array,
                {
                  show_as: i === 0 ? "bar" : "line",
                  y_axis_map_at: i === 0 ? 0 : 1,
                  y_axis_scale: "linear",
                  color_pattern_code: 1,
                  key: uuid(),
                },
              ];
            }
          });
          updateWidgetGraphConfig.y_axis_settings = y_axis_settings_array;
          updateWidgetGraphConfig.y_axis = yseriesObject;
        } else {
          updateWidgetGraphConfig.y_axis = {
            y_series_1: {
              attribute: null,
              aggregation: "COUNT",
            },
            y_series_2: {
              attribute: null,
              aggregation: "COUNT",
            },
          };
        }
      } else {
        // For Edit widget in dashboards
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
          y_series_2: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    }
  } else if (value === "networkgraph") {
    if (updateWidgetGraphConfig.x_axis) {
      let radiusAttribute = getRadiusAttributeValue(
        graphConditions,
        value,
        updateWidgetGraphConfig?.x_axis?.attribute
      );
      updateWidgetGraphConfig.x_axis.x_limit = 30;
      updateWidgetGraphConfig.x_axis.radius_attribute = radiusAttribute;
      updateWidgetGraphConfig.x_axis.color = updateWidgetGraphConfig?.x_axis
        ?.color
        ? updateWidgetGraphConfig?.x_axis?.color
        : globalChartColor?.[0];
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null;
    updateWidgetGraphConfig.chart_settings.is_stacked_disabled = false;
    if (updateWidgetGraphConfig.breakdown_by?.length > 0) {
      updateWidgetGraphConfig.breakdown_by.map((d, index) => {
        let radiusAttribute = getRadiusAttributeValue(
          graphConditions,
          value,
          d?.attribute
        );
        d.is_pivot = false;
        d.radius_attribute = radiusAttribute;
        d.color = d?.color ? d?.color : globalChartColor?.[index];
      });
    }

    updateWidgetGraphConfig.x_axis = updateWidgetGraphConfig.x_axis;
    updateWidgetGraphConfig.breakdown_by = updateWidgetGraphConfig.breakdown_by;
  } else if (value === "scatter") {
    updateWidgetGraphConfig.x_axis = null;
    updateWidgetGraphConfig.breakdown_by = [];
    updateWidgetGraphConfig.y_axis = {
      y_series_1: {
        attribute: null,
        aggregation: "COUNT",
      },
      y_series_2: {
        attribute: null,
        aggregation: "COUNT",
      },
    };
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null;
  } else if (value === "rich-text") {
    updateWidgetGraphConfig.x_axis = null;
    updateWidgetGraphConfig.breakdown_by = [];
    updateWidgetGraphConfig.y_axis = {
      y_series_1: {
        attribute: null,
        aggregation: "COUNT",
      },
    };
    // To reset the added cards from card settings
    if (
      updateWidgetGraphConfig?.card_settings?.[0]?.x_axis ||
      updateWidgetGraphConfig?.card_settings?.[0]?.y_series?.attribute
    ) {
      updateWidgetGraphConfig.card_settings = [
        {
          card_id: uuid(),
          card_name: 1,
          card_value: null,
          x_axis: null,
          y_series: null,
          response: [],
        },
      ];
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null;
  } else if (
    value === "sankey" ||
    value === "quadrant" ||
    value === "multilayer-map" ||
    value === "treemap" ||
    value === "cluster-chart"
  ) {
    updateWidgetGraphConfig.x_axis = null;
    updateWidgetGraphConfig.breakdown_by = [];
    updateWidgetGraphConfig.y_axis = {
      y_series_1: {
        attribute: null,
        aggregation: "COUNT",
      },
    };

    if (value === "treemap") {
      updateWidgetGraphConfig.chart_settings.global_data_label = true;
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null;
  } else if (
    value === "bar" ||
    value === "horizontal-bar" ||
    value === "area" ||
    value === "line" ||
    value === "lollipop"
  ) {
    if (
      (value === "lollipop" || value === "bar" || value === "horizontal-bar") &&
      updateWidgetGraphConfig?.chart_settings?.show_peak
    ) {
      updateWidgetGraphConfig.chart_settings.show_peak = false;
    }
    if (
      (value === "lollipop" || value === "bar" || value === "horizontal-bar") &&
      updateWidgetGraphConfig?.chart_settings?.show_valley
    ) {
      updateWidgetGraphConfig.chart_settings.show_valley = false;
    }
    if (
      value === "line" ||
      value === "bar" ||
      value === "lollipop" ||
      (value === "horizontal-bar" && obj?.chart_type == "area")
    ) {
      updateWidgetGraphConfig.chart_settings.chart_percent = false;
    }

    if (
      (value === "lollipop" ||
        value === "bar" ||
        value === "horizontal-bar" ||
        value === "area") &&
      updateWidgetGraphConfig?.chart_settings?.show_3d
    ) {
      updateWidgetGraphConfig.chart_settings.settings_3d = {
        alpha: DEFAULT_CHART_SETTINGS[value].alpha,
        beta: DEFAULT_CHART_SETTINGS[value].beta,
        depth: DEFAULT_CHART_SETTINGS[value].depth,
      };
    }
    if (value === "line") {
      updateWidgetGraphConfig.chart_settings.show_3d = false;
      updateWidgetGraphConfig.chart_settings.settings_3d = null;
    }

    if (updateWidgetGraphConfig.x_axis) {
      updateWidgetGraphConfig.x_axis.x_limit = 30;
    }
    //by default stacked is set false in case of area chart to avoid data points confusion in multiple area chart
    if (value === "area") {
      updateWidgetGraphConfig.chart_settings.is_stacked = false;
    }
    if (value === "horizontal-bar") {
      if (
        updateWidgetGraphConfig?.brands &&
        updateWidgetGraphConfig?.brands?.length &&
        updateWidgetGraphConfig?.brands?.[0].competitor
      ) {
        updateWidgetGraphConfig.chart_settings.benchmark_line = false;
        updateWidgetGraphConfig.chart_settings.group_line_agg = null;
        updateWidgetGraphConfig.chart_settings.benchmark_static_value = null;
      }
    }
    updateWidgetGraphConfig.filter_by = [];
    if (updateWidgetGraphConfig.breakdown_by?.length > 1) {
      while (updateWidgetGraphConfig.breakdown_by.length > 1) {
        updateWidgetGraphConfig.breakdown_by.pop();
      }
      updateWidgetGraphConfig.breakdown_by.map((d) => {
        d.is_pivot = false;
        if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
          d.date_part = d?.date_part
            ? ["ww", "mm", "qq"]?.includes(d?.date_part)
              ? d?.date_part
              : "ww"
            : "ww";
          if (d?.date_aggregation) delete d?.date_aggregation;
        }
      });
    }

    if (Object.keys(finalUpdateYseries)?.length > 0) {
      let arr = [];
      arr = Object.keys(finalUpdateYseries).map(
        (key) => finalUpdateYseries[key]
      );
      let filteredArray = arr?.filter((d) => d.attribute);

      if (filteredArray?.length > 0) {
        let yseriesObject = {};
        let y_axis_settings_array = [];

        Object.entries(filteredArray).forEach((e, i) => {
          if (i < 10) {
            if (e?.[1]?.info_text) {
              delete e?.[1]?.info_text;
            }
            if (e?.[1]?.variable_size) {
              delete e?.[1]?.variable_size;
            }
            yseriesObject = {
              ...yseriesObject,
              [`y_series_${i + 1}`]: { ...e[1] },
            };
            y_axis_settings_array = [
              ...y_axis_settings_array,
              {
                show_as: i === 0 ? "bar" : "line",
                y_axis_map_at: i === 0 ? 0 : 1,
                y_axis_scale: "linear",
                color_pattern_code: 1,
                key: uuid(),
              },
            ];
          }
        });

        updateWidgetGraphConfig.y_axis_settings = y_axis_settings_array;
        updateWidgetGraphConfig.y_axis = yseriesObject;
        // added ticket-time so attrs reset on change from
        if (
          (graphConditions?.["time-label-attrs"]?.includes(
            finalUpdateYseries?.y_series_1?.attribute
          ) &&
            !graphConditions?.["time-label-attrs"]?.includes(
              finalUpdateYseries?.y_series_2?.attribute
            )) ||
          (graphConditions?.["ticket-time-label-attrs"]?.includes(
            finalUpdateYseries?.y_series_1?.attribute
          ) &&
            !graphConditions?.["ticket-time-label-attrs"]?.includes(
              finalUpdateYseries?.y_series_2?.attribute
            ))
        ) {
          updateWidgetGraphConfig.x_axis = null;
          updateWidgetGraphConfig.breakdown_by = [];
          updateWidgetGraphConfig.y_axis = {
            y_series_1: {
              attribute: null,
              aggregation: "COUNT",
            },
          };
        }
      } else {
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    } else {
      // For Edit widget in dashboards
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    updateWidgetGraphConfig.x_axis = updateWidgetGraphConfig.x_axis;

    // to check and updated date_part value of breakdown_by
    if (
      updateWidgetGraphConfig?.breakdown_by &&
      updateWidgetGraphConfig?.breakdown_by?.length
    ) {
      updateWidgetGraphConfig.breakdown_by =
        updateWidgetGraphConfig?.breakdown_by?.map((d) => {
          if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
            d.date_part = d?.date_part
              ? ["ww", "mm", "qq"]?.includes(d?.date_part)
                ? d?.date_part
                : "ww"
              : "ww";
            if (d?.date_aggregation) delete d?.date_aggregation;
          }
          return d;
        });
    }

    updateWidgetGraphConfig.breakdown_by = updateWidgetGraphConfig.breakdown_by;
  } else if (value === "scatter" || value === "quadrant") {
    // for now removing this checks
    // updateWidgetGraphConfig.y_axis_settings = [];
    // if (Object.keys(finalUpdateYseries)?.length > 0) {
    //   let arr = [];
    //   arr = Object.keys(finalUpdateYseries).map(
    //     (key) => finalUpdateYseries[key]
    //   );
    //   let filteredArray = arr?.filter((d) => d.attribute);
    //   let yseriesObject = {};
    //   if (filteredArray?.length > 0) {
    //     Object.entries(filteredArray).forEach((e, i) => {
    //       if (e?.[1]?.info_text) {
    //         delete e?.[1]?.info_text;
    //       }
    //       if (e?.[1]?.variable_size) {
    //         delete e?.[1]?.variable_size;
    //       }
    //       if (i < 1) {
    //         yseriesObject = {
    //           ...yseriesObject,
    //           [`y_series_${i + 1}`]:
    //             value === "kpi" ? { ...e[1] } : { ...e[1], filters: [] },
    //         };
    //       }
    //     });
    //     updateWidgetGraphConfig.y_axis = yseriesObject;
    //   } else {
    //     updateWidgetGraphConfig.y_axis = {
    //       y_series_1: {
    //         attribute: null,
    //         aggregation: "COUNT",
    //       },
    //     };
    //   }
    // } else {
    //   // For Edit widget in dashboards
    //   updateWidgetGraphConfig.y_axis = {
    //     y_series_1: {
    //       attribute: null,
    //       aggregation: "COUNT",
    //     },
    //   };
    // }
  } else if (
    value === "donut" ||
    value === "pie" ||
    value === "kpi" ||
    value === "wordcloud"
  ) {
    // need to check here
    updateWidgetGraphConfig.y_axis_settings = [];
    if (value === "kpi") {
      // set split card false
      updateWidgetGraphConfig.chart_settings.split_cards = false;
    }
    if (updateWidgetGraphConfig.x_axis && value === "kpi") {
      updateWidgetGraphConfig.x_axis.x_limit = 10;
    }
    if (
      (value === "donut" || value === "pie") &&
      updateWidgetGraphConfig?.chart_settings?.show_3d
    ) {
      updateWidgetGraphConfig.chart_settings.settings_3d = {
        alpha: DEFAULT_CHART_SETTINGS[value].alpha,
        beta: DEFAULT_CHART_SETTINGS[value].beta,
        depth: DEFAULT_CHART_SETTINGS[value].depth,
      };
    }
    if (value === "kpi" || value === "wordcloud") {
      updateWidgetGraphConfig.chart_settings.show_3d = false;
      updateWidgetGraphConfig.chart_settings.settings_3d = null;
    }
    if (Object.keys(finalUpdateYseries)?.length > 0) {
      let arr = [];
      arr = Object.keys(finalUpdateYseries).map(
        (key) => finalUpdateYseries[key]
      );
      let filteredArray = arr?.filter((d) => d.attribute);
      let yseriesObject = {};
      if (filteredArray?.length > 0) {
        Object.entries(filteredArray).forEach((e, i) => {
          if (e?.[1]?.info_text) {
            delete e?.[1]?.info_text;
          }
          if (e?.[1]?.variable_size) {
            delete e?.[1]?.variable_size;
          }
          if (i < 1) {
            yseriesObject = {
              ...yseriesObject,
              [`y_series_${i + 1}`]:
                value === "kpi" ? { ...e[1] } : { ...e[1], filters: [] },
            };
          }
        });
        updateWidgetGraphConfig.y_axis = yseriesObject;
      } else {
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    } else {
      // For Edit widget in dashboards
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.breakdown_by = [];
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (
      value === "kpi" &&
      (updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
        "hashtags" ||
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "keyword" ||
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "tagcloud" ||
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "createddate")
    ) {
      if (updateWidgetGraphConfig.x_axis) {
        updateWidgetGraphConfig.x_axis.x_limit = 10;
      }
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (value === "pie" || value === "donut") {
      if (updateWidgetGraphConfig.x_axis) {
        updateWidgetGraphConfig.x_axis.x_limit = 6;
      }
      if (
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
        "createddate"
      ) {
        updateWidgetGraphConfig.x_axis.date_part = "ww";
        if (updateWidgetGraphConfig?.x_axis?.date_aggregation)
          delete updateWidgetGraphConfig?.x_axis?.date_aggregation;
      }
      updateWidgetGraphConfig.x_axis = updateWidgetGraphConfig.x_axis;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = updateWidgetGraphConfig.y_axis;
    } else if (value === "wordcloud") {
      if (updateWidgetGraphConfig.x_axis) {
        updateWidgetGraphConfig.x_axis.x_limit = 20;
      }
      if (
        updateWidgetGraphConfig?.x_axis &&
        (updateWidgetGraphConfig?.x_axis.attribute?.toLowerCase() ===
          "rating" ||
          updateWidgetGraphConfig?.x_axis.attribute?.toLowerCase() ===
            "createddate")
      ) {
        updateWidgetGraphConfig.x_axis = null;
        updateWidgetGraphConfig.breakdown_by = [];
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      } else {
        if (obj?.y_axis?.y_series_1?.info_text) {
          delete obj?.y_axis?.y_series_1?.info_text;
        }
        if (obj?.y_axis?.y_series_1?.variable_size) {
          delete obj?.y_axis?.y_series_1?.variable_size;
        }
        updateWidgetGraphConfig.breakdown_by = [];
        updateWidgetGraphConfig.y_axis = {};
        updateWidgetGraphConfig.y_axis =
          Object.keys(obj.y_axis)?.length > 0
            ? {
                y_series_1: {
                  ...obj.y_axis.y_series_1,
                  filters: [],
                },
              }
            : {
                y_series_1: {
                  attribute: null,
                  aggregation: "COUNT",
                },
              };
      }
    }
  } else if (value === "map") {
    updateWidgetGraphConfig.y_axis_settings = [];
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (Object.keys(finalUpdateYseries)?.length > 0) {
      let arr = [];
      arr = Object.keys(finalUpdateYseries).map(
        (key) => finalUpdateYseries[key]
      );
      let filteredArray = arr?.filter((d) => d.attribute);
      let yseriesObject = {};
      if (filteredArray?.length > 0) {
        Object.entries(filteredArray).forEach((e, i) => {
          if (e?.[1]?.info_text) {
            delete e?.[1]?.info_text;
          }
          if (e?.[1]?.variable_size) {
            delete e?.[1]?.variable_size;
          }
          if (i < 1) {
            yseriesObject = {
              ...yseriesObject,
              [`y_series_${i + 1}`]: { ...e[1], filters: [] },
            };
          }
        });
        updateWidgetGraphConfig.y_axis = yseriesObject;
      } else {
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    } else {
      // For Edit widget in dashboards
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }

    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    if (
      updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
      "createddate"
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }
    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else {
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.x_axis = null;
    }
  } else if (
    value === "grid" ||
    value === "networkgraph" ||
    value === "cluster-chart"
  ) {
    if (!updateWidgetGraphConfig?.chart_settings?.show_peak) {
      updateWidgetGraphConfig.chart_settings.show_peak = true;
    }
    if (!updateWidgetGraphConfig?.chart_settings?.show_valley) {
      updateWidgetGraphConfig.chart_settings.show_valley = true;
    }
    if (
      updateWidgetGraphConfig?.chart_settings
        ?.show_previous_duration_comparison &&
      updateWidgetGraphConfig?.chart_settings?.show_previous_duration_data
    ) {
      updateWidgetGraphConfig.chart_settings.show_previous_duration_comparison = false;
      updateWidgetGraphConfig.chart_settings.show_previous_duration_data = false;
    }
    updateWidgetGraphConfig.y_axis_settings = [];
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (updateWidgetGraphConfig.x_axis) {
      if (value === "cluster-chart") {
        updateWidgetGraphConfig.x_axis.x_limit = 5;
      } else {
        updateWidgetGraphConfig.x_axis.x_limit = 50;
      }
    }
    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    // if (updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() === "createddate") {
    //   updateWidgetGraphConfig.x_axis = null;
    //   updateWidgetGraphConfig.breakdown_by = [];
    //   updateWidgetGraphConfig.y_axis = {
    //     y_series_1: {
    //       attribute: null,
    //       aggregation: "COUNT",
    //     },
    //   };
    // }
    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      ) ||
      graphConditions?.["ticket-time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (
      updateWidgetGraphConfig?.x_axis?.attribute === "Hashtags" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "Keyword" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "TagCloud"
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else {
      // To Reset filter in grid chart or networkgraph
      if (
        value === "grid" ||
        value === "networkgraph" ||
        value === "network-graph" ||
        value === "network-graph-v2" ||
        value === "cluster-chart"
      ) {
        if (Object.keys(finalUpdateYseries)?.length > 0) {
          let arr = [];
          arr = Object.keys(finalUpdateYseries).map(
            (key) => finalUpdateYseries[key]
          );
          let filteredArray = arr?.filter((d) => d.attribute);
          let yseriesObject = {};
          if (filteredArray?.length > 0) {
            Object.entries(filteredArray).forEach((e, i) => {
              if (i < 6) {
                if (e?.[1]?.info_text) {
                  delete e?.[1]?.info_text;
                }
                if (e?.[1]?.variable_size) {
                  delete e?.[1]?.variable_size;
                }
                yseriesObject = {
                  ...yseriesObject,
                  [`y_series_${i + 1}`]: { ...e[1], filters: [] },
                };
              }
            });
            updateWidgetGraphConfig.y_axis = yseriesObject;
          } else {
            updateWidgetGraphConfig.y_axis = {
              y_series_1: {
                attribute: null,
                aggregation: "COUNT",
              },
            };
          }
        }
      } else {
        // For Edit widget in dashboards
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
      // To Reset filter in networkgraph
      if (value === "networkgraph") {
        if (Object.keys(finalUpdateYseries)?.length > 0) {
          let arr = [];
          arr = Object.keys(finalUpdateYseries).map(
            (key) => finalUpdateYseries[key]
          );
          let filteredArray = arr?.filter((d) => d.attribute);
          let yseriesObject = {};
          if (filteredArray?.length > 0) {
            Object.entries(filteredArray).forEach((e, i) => {
              if (i < 1) {
                yseriesObject = {
                  ...yseriesObject,
                  [`y_series_${i + 1}`]: { ...e[1], filters: [] },
                };
              }
            });
            updateWidgetGraphConfig.y_axis = yseriesObject;
          } else {
            updateWidgetGraphConfig.y_axis = {
              y_series_1: {
                attribute: null,
                aggregation: "COUNT",
              },
            };
          }
        }
      }
      if (updateWidgetGraphConfig.breakdown_by?.length > 0)
        while (updateWidgetGraphConfig.breakdown_by.length > 2) {
          updateWidgetGraphConfig.breakdown_by.pop();
        }
      updateWidgetGraphConfig.breakdown_by?.map((d) => {
        if (value !== "cluster-chart") {
          d.y_limit = null;
        }
        if (d?.is_pivot) {
          d.is_pivot = false;
        }
        if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
          d.date_part = d?.date_part
            ? ["ww", "mm", "qq"]?.includes(d?.date_part)
              ? d?.date_part
              : "ww"
            : "ww";
          if (d?.date_aggregation) delete d?.date_aggregation;
        }
        return d;
      });
    }
  } else if (value === "pivot-grid") {
    if (!updateWidgetGraphConfig?.chart_settings?.show_peak) {
      updateWidgetGraphConfig.chart_settings.show_peak = true;
    }
    if (!updateWidgetGraphConfig?.chart_settings?.show_valley) {
      updateWidgetGraphConfig.chart_settings.show_valley = true;
    }

    updateWidgetGraphConfig.y_axis_settings = [];
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (updateWidgetGraphConfig.x_axis) {
      updateWidgetGraphConfig.x_axis.x_limit = 50;
    }
    if (Object.keys(finalUpdateYseries)?.length > 0) {
      let arr = [];
      arr = Object.keys(finalUpdateYseries).map(
        (key) => finalUpdateYseries[key]
      );
      let filteredArray = arr?.filter((d) => d.attribute);
      let yseriesObject = {};
      if (filteredArray?.length > 0) {
        Object.entries(filteredArray).forEach((e, i) => {
          if (i < 1) {
            if (e?.[1]?.info_text) {
              delete e?.[1]?.info_text;
            }
            if (e?.[1]?.variable_size) {
              delete e?.[1]?.variable_size;
            }
            yseriesObject = {
              ...yseriesObject,
              [`y_series_${i + 1}`]: { ...e[1], filters: [] },
            };
          }
        });
        updateWidgetGraphConfig.y_axis = yseriesObject;
      } else {
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    } else {
      // For Edit widget in dashboards
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }

    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    // disabled span on functionality in pivot grid chart that's why assigning false here
    if (updateWidgetGraphConfig?.x_axis?.attribute) {
      updateWidgetGraphConfig.x_axis = {
        ...updateWidgetGraphConfig?.x_axis,
        span_on: false,
      };
    }

    // if (updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() === "createddate") {
    //   updateWidgetGraphConfig.x_axis = null;
    //   updateWidgetGraphConfig.breakdown_by = [];
    //   updateWidgetGraphConfig.y_axis = {
    //     y_series_1: {
    //       attribute: null,
    //       aggregation: "COUNT",
    //     },
    //   };
    // }
    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      ) ||
      graphConditions?.["ticket-time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (
      updateWidgetGraphConfig?.x_axis?.attribute === "Hashtags" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "Keyword" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "TagCloud"
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (
      value === "pivot-grid" &&
      updateWidgetGraphConfig.breakdown_by?.length > 0
    ) {
      if (updateWidgetGraphConfig.breakdown_by?.length > 1) {
        while (updateWidgetGraphConfig.breakdown_by.length > 1) {
          updateWidgetGraphConfig.breakdown_by.pop();
        }
      }
      updateWidgetGraphConfig.breakdown_by =
        updateWidgetGraphConfig.breakdown_by
          ?.map((d) => {
            d.y_limit = 10;
            if (
              d?.is_pivot ||
              updateWidgetGraphConfig.breakdown_by?.length === 1
            ) {
              d.is_pivot = true;
            }
            if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
              d.date_part = d?.date_part
                ? ["ww", "mm", "qq"]?.includes(d?.date_part)
                  ? d?.date_part
                  : "ww"
                : null;
              if (d?.date_aggregation) delete d?.date_aggregation;
            }
            return graphConditions?.["pivot-grid"]?.y_axes?.include?.includes(
              d?.attribute?.toLowerCase()
            )
              ? d
              : null;
          })
          .filter(Boolean);
    }
  } else if (
    value === "post-card" ||
    value === "survey-card" ||
    value === "news-card"
  ) {
    updateWidgetGraphConfig.order_by = null; //for prolific user data to get cleared
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    // To reset the added cards from card settings
    if (
      updateWidgetGraphConfig?.card_settings?.[0]?.x_axis &&
      value !== "news-card"
    ) {
      updateWidgetGraphConfig.card_settings = [
        {
          card_id: uuid(),
          card_name: 1,
          card_value: null,
          x_axis: null,
          y_series: null,
          response: [],
        },
      ];
    }

    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
      let obj = {
        attribute: "engagement",
        offset: 0,
        sort_order: "desc",
        trace_name: "Total Engagement",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
    } else {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      if (value == "news-card") {
        updateWidgetGraphConfig.y_axes = null;
        updateWidgetGraphConfig.y_axis = [];
        updateWidgetGraphConfig.x_axis = null;
        updateWidgetGraphConfig.filter_by = null;
        updateWidgetGraphConfig.filter_by_data = null;
      } else {
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
      let obj = {
        attribute: "engagement",
        offset: 0,
        sort_order: "desc",
        trace_name: "Total Engagement",
      };
      if (value === "news-card") {
        let newsCardObj = {
          attribute: "NumLikesCount",
          offset: 0,
          sort_order: "desc",
          trace_name: "Post Likes",
        };
        updateWidgetGraphConfig.order_by = newsCardObj;
        updateWidgetGraphConfig.data_source = "mentions";
      } else {
        updateWidgetGraphConfig.order_by = obj;
        updateWidgetGraphConfig.data_source = "mentions";
      }
    }
  } else if (value === "review-card") {
    // To reset the added cards from card settings
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (updateWidgetGraphConfig?.card_settings?.[0]?.x_axis) {
      updateWidgetGraphConfig.card_settings = [
        {
          card_id: uuid(),
          card_name: 1,
          card_value: null,
          x_axis: null,
          y_series: null,
          response: [],
        },
      ];
    }

    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
      let obj = {
        attribute: "engagement",
        offset: 0,
        sort_order: "desc",
        trace_name: "Total Engagement",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
    } else {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
      let obj = {
        attribute: "CreatedDate",
        offset: 0,
        sort_order: "desc",
        trace_name: "Date",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
    }
  } else if (value === "author-card") {
    // To reset the added cards from card settings
    updateWidgetGraphConfig.chart_settings.show_3d = false;
    updateWidgetGraphConfig.chart_settings.settings_3d = null;

    if (updateWidgetGraphConfig?.card_settings?.[0]?.y_series?.attribute) {
      updateWidgetGraphConfig.card_settings = [
        {
          card_id: uuid(),
          card_name: 1,
          card_value: null,
          x_axis: null,
          y_series: null,
          response: [],
        },
      ];
    }

    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
      let obj = {
        attribute: "engagement",
        offset: 0,
        sort_order: "desc",
        trace_name: "Total Engagement",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
    } else {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
      let obj = {
        attribute:
          workspace_privileges?.environment === 1
            ? "FollowersCount"
            : "followerscount",
        offset: 0,
        sort_order: "desc",
        trace_name: "Followers",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
    }
  } else if (
    value !== "pivot-grid" &&
    updateWidgetGraphConfig.breakdown_by?.length > 0
  ) {
    if (value === "prolific-user") {
      updateWidgetGraphConfig.chart_settings.show_3d = false;
      updateWidgetGraphConfig.chart_settings.settings_3d = null;
      updateWidgetGraphConfig.filter_by = [];
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };

      let obj = {
        attribute: "engagement",
        offset: 0,
        sort_order: "desc",
        trace_name: "Total Engagement",
      };
      updateWidgetGraphConfig.order_by = obj;
      updateWidgetGraphConfig.data_source = "mentions";
      if (
        updateWidgetGraphConfig?.brands?.[0]?.competitor ||
        updateWidgetGraphConfig?.brands?.[0]?.group ||
        !updateWidgetGraphConfig?.brands
      ) {
        updateWidgetGraphConfig.brands = [brands[0]];
      }
    }
    if (
      value === "bubble" ||
      value === "heatmap" ||
      value === "sunburst" ||
      value === "sankey"
    ) {
      updateWidgetGraphConfig.chart_settings.show_3d = false;
      updateWidgetGraphConfig.chart_settings.settings_3d = null;
      if (value === "bubble") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 20;
        }
      } else if (value === "heatmap") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 30;
        }
      } else if (value === "sunburst") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 10;
        }
      } else if (value === "sankey") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 10;
        }
      }

      if (Object.keys(finalUpdateYseries)?.length > 0) {
        let arr = [];
        arr = Object.keys(finalUpdateYseries).map(
          (key) => finalUpdateYseries[key]
        );
        let filteredArray = arr?.filter((d) => d.attribute);
        let yseriesObject = {};
        if (filteredArray?.length > 0) {
          Object.entries(filteredArray).forEach((e, i) => {
            if (i < 1) {
              if (e?.[1]?.info_text) {
                delete e?.[1]?.info_text;
              }
              if (e?.[1]?.variable_size) {
                delete e?.[1]?.variable_size;
              }
              yseriesObject = {
                ...yseriesObject,
                [`y_series_${i + 1}`]: { ...e[1], filters: [] },
              };
            }
          });
          updateWidgetGraphConfig.y_axis = yseriesObject;
        } else {
          updateWidgetGraphConfig.y_axis = {
            y_series_1: {
              attribute: null,
              aggregation: "COUNT",
            },
          };
        }
      } else {
        // For Edit widget in dashboards
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }

      if (
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "createddate" ||
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "rating" ||
        updateWidgetGraphConfig?.breakdown_by
          ?.map((d) => d?.attribute?.toLowerCase())
          ?.includes("rating")
      ) {
        updateWidgetGraphConfig.x_axis = null;
        updateWidgetGraphConfig.breakdown_by = [];
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
      updateWidgetGraphConfig.order_by = null;
    }

    if (updateWidgetGraphConfig.breakdown_by?.length > 1) {
      while (updateWidgetGraphConfig.breakdown_by.length > 1) {
        updateWidgetGraphConfig.breakdown_by.pop();
      }
      updateWidgetGraphConfig.breakdown_by.map((d) => {
        d.is_pivot = false;
        if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
          d.date_part = d?.date_part
            ? ["ww", "mm", "qq"]?.includes(d?.date_part)
              ? d?.date_part
              : "ww"
            : "ww";
          if (d?.date_aggregation) delete d?.date_aggregation;
        }
      });
    }
    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else if (
      updateWidgetGraphConfig?.x_axis?.attribute === "Hashtags" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "Keyword" ||
      updateWidgetGraphConfig?.x_axis?.attribute === "TagCloud"
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    } else {
      updateWidgetGraphConfig.breakdown_by?.map((d) => {
        if (d?.is_pivot) {
          d.is_pivot = false;
        }
        if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
          d.date_part = d?.date_part
            ? ["ww", "mm", "qq"]?.includes(d?.date_part)
              ? d?.date_part
              : "ww"
            : "ww";
          if (d?.date_aggregation) delete d?.date_aggregation;
        }
        return d;
      });
    }
  } else if (value === "prolific-user") {
    // To reset the added cards from card settings
    if (updateWidgetGraphConfig?.card_settings?.[0]?.x_axis) {
      updateWidgetGraphConfig.card_settings = [
        {
          card_id: uuid(),
          card_name: 1,
          card_value: null,
          x_axis: null,
          y_series: null,
          response: [],
        },
      ];
    }

    updateWidgetGraphConfig.filter_by = [];
    updateWidgetGraphConfig.x_axis = null;
    updateWidgetGraphConfig.breakdown_by = [];
    updateWidgetGraphConfig.y_axis = {
      y_series_1: {
        attribute: null,
        aggregation: "COUNT",
      },
    };

    let obj = {
      attribute: "engagement",
      offset: 0,
      sort_order: "desc",
      trace_name: "Total Engagement",
    };
    updateWidgetGraphConfig.order_by = obj;
    updateWidgetGraphConfig.data_source = "mentions";
    if (
      updateWidgetGraphConfig?.brands?.[0]?.competitor ||
      updateWidgetGraphConfig?.brands?.[0]?.group ||
      !updateWidgetGraphConfig?.brands
    ) {
      updateWidgetGraphConfig.brands = [brands[0]];
    }
  } else if (value !== "prolific-user") {
    if (updateWidgetGraphConfig.breakdown_by?.length > 1) {
      while (updateWidgetGraphConfig.breakdown_by.length > 1) {
        updateWidgetGraphConfig.breakdown_by.pop();
      }
      updateWidgetGraphConfig.breakdown_by.map((d) => {
        d.is_pivot = false;
        if (graphConditions?.["date-attributes"]?.includes(d?.attribute)) {
          d.date_part = d?.date_part
            ? ["ww", "mm", "qq"]?.includes(d?.date_part)
              ? d?.date_part
              : "ww"
            : "ww";
          if (d?.date_aggregation) delete d?.date_aggregation;
        }
      });
    }
    updateWidgetGraphConfig.order_by = null;

    if (
      updateWidgetGraphConfig.y_axis?.y_series_1?.attribute === "nss" ||
      finalUpdateYseries?.y_series_1?.attribute === "srs" ||
      graphConditions?.["time-label-attrs"]?.includes(
        finalUpdateYseries?.y_series_1?.attribute
      )
    ) {
      updateWidgetGraphConfig.x_axis = null;
      updateWidgetGraphConfig.breakdown_by = [];
      updateWidgetGraphConfig.y_axis = {
        y_series_1: {
          attribute: null,
          aggregation: "COUNT",
        },
      };
    }

    if (
      value === "bubble" ||
      value === "heatmap" ||
      value === "sunburst" ||
      value === "sankey"
    ) {
      if (value === "bubble") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 20;
        }
      } else if (value === "heatmap") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 30;
        }
      } else if (value === "sunburst") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 10;
        }
      } else if (value === "sankey") {
        if (updateWidgetGraphConfig.x_axis) {
          updateWidgetGraphConfig.x_axis.x_limit = 10;
        }
      }

      if (
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "createddate" ||
        updateWidgetGraphConfig?.x_axis?.attribute?.toLowerCase() ===
          "rating" ||
        updateWidgetGraphConfig?.breakdown_by
          ?.map((d) => d?.attribute?.toLowerCase())
          ?.includes("rating")
      ) {
        updateWidgetGraphConfig.x_axis = null;
        updateWidgetGraphConfig.breakdown_by = [];
        updateWidgetGraphConfig.y_axis = {
          y_series_1: {
            attribute: null,
            aggregation: "COUNT",
          },
        };
      }
    }
  }
  if (value !== "grid" && value !== "cluster-chart") {
    updateWidgetGraphConfig.chart_settings.show_previous_duration_comparison = false;
    updateWidgetGraphConfig.chart_settings.show_previous_duration_data = false;
  }

  // For all chart switch se data source to mentions
  updateWidgetGraphConfig.data_source = "mentions";
  return (dispatch) => {
    dispatch(setDataSource(updateWidgetGraphConfig.data_source));
    dispatch({
      type: "SET_WIDGET_CHART_TYPE",
      widgetGraphConfig: { ...updateWidgetGraphConfig },
    });
  };
};

export const setWidgetChartName = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_property.chart_name = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_CHART_NAME",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetChartDescription = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.widget_description = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_CHART_DESCRIPTION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetTags = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.tags = value;
  return (dispatch) => {
    dispatch({
      type: "SET_TAGS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetLegendPosition = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_property.legend_position = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_LEGEND_POSITION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setShowLegend = (value, obj) => {
  let updatedWidgetGraphConfig = { ...obj };
  updatedWidgetGraphConfig.chart_property.show_legend = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SHOW_LEGEND",
      widgetGraphConfig: updatedWidgetGraphConfig,
    });
  };
};

export const setWidgetNumberTopPosts = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_property.no_of_top_posts = value;
  if (updateWidgetGraphConfig?.order_by?.offset) {
    updateWidgetGraphConfig.order_by.offset = 0;
  }
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_NUMBER_TOP_POSTS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalHorizontalView = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_horizontal_view = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_HORIZONTAL_VIEW",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetGlobalDataLabel = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.global_data_label = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_DATA_LABEL",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalShowDetailsOnCard = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_details_on_card = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_SHOW_DETAILS_ON_CARD",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetEnable3D = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_3d = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_ENABLE_3D",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidget3dOption = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.settings_3d = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_ENABLE_3D",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetChartStylesOption = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.chart_styles = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_CHART_STYLES_OPTION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetDuplicateForBrands = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.duplicate_for_brands = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_DUPLICATE_FOR_BRANDS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetSwitchToMedian = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_as_median = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_SHOW_AS_MEDIAN",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetDataLabelInPercent = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.chart_percent = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_DATA_LABEL_IN_PERCENT",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGradientColor = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.gradient_color = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GRADIENT_COLOR",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalStacked = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.is_stacked = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_STACKED",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalStackedToDisabled = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.is_stacked_disabled = value;
  updateWidgetGraphConfig.chart_settings.is_stacked = !value;
  updateWidgetGraphConfig.chart_settings.gradient_color = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_STACKED_DISABLED",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalDurationComparision = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.duration_comparison = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_DURATION_COMPARISION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalDurationComparisionForChart = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_previous_duration_comparison =
    value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_DURATION_COMPARISION_FOR_CHART",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetGlobalDurationDataForChart = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_previous_duration_data = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GLOBAL_DURATION_DATA_FOR_CHART",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetShareOfData = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.card_percent = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_SHARE_OF_DATA",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetTotalRow = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.total_row = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_TOTAL_ROW",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetMakerSplitCards = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.split_cards = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_SPLIT_CARDS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetMakerTopPosts = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.top_posts_in_cards = value;
  updateWidgetGraphConfig.chart_property.no_of_top_posts = 1;
  if (updateWidgetGraphConfig?.order_by?.offset) {
    updateWidgetGraphConfig.order_by.offset = 0;
  }
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_TOP_POSTS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetMakerDyanamicRadius = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.dynamic_radius = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_DYNAMIC_RADIUS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetMakerBorderSentiment = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.border_sentiment = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_BORDER_SENTIMENT",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetMakerDataSource = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.data_source = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_DATA_SOURCE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setWidgetMakerShowHeader = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_header = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_MAKER_SHOW_HEADER",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetChartMarkers = (value, obj) => {
  //dynamic
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.show_marker = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_SHOW_MARKER",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetDataCountCard = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.data_count_card = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_DATA_COUNT_CARD",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setCardBenchmarkStaticValue = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.benchmark_static_value = value;
  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETTING_BENCHMARK_STATIC_VALUE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setCardSeriesAggregation = (
  value,
  obj,
  benchmarkStaticValue = null
) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.group_line_agg = value;
  if (
    updateWidgetGraphConfig?.chart_settings?.benchmark_static_value &&
    value !== "custom"
  ) {
    updateWidgetGraphConfig.chart_settings.benchmark_static_value = null;
  }
  if (value === "custom" && benchmarkStaticValue) {
    updateWidgetGraphConfig.chart_settings.benchmark_static_value =
      benchmarkStaticValue;
  }
  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETTING_BENCHMARK_LINE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setCardBenchmarkLine = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.benchmark_line = value;
  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETTING_BENCHMARK_LINE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetCardPosition = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.card_position = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_CARD_POSITION",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetCardLimit = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.card_limit = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_CARD_LIMIT",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setCardSettings = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETIINGS",
      widgetGraphConfig: value,
    });
  };
};

export const setYAxisScale = (value, obj) => {
  //dynamic
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.y_axis_scale = value;
  return (dispatch) => {
    dispatch({
      type: "SET_Y_AXIS_SCALE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setCardSettingsData = (value, index, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  if (
    updateWidgetGraphConfig?.card_settings &&
    updateWidgetGraphConfig?.card_settings?.length
  ) {
    updateWidgetGraphConfig?.card_settings?.forEach((card) => {
      if (card?.response) delete card?.response;
    });
  }
  updateWidgetGraphConfig.card_settings[index].response = value;

  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETIINGS_DATA",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setCardSettingsCardData = (value, index, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.card_settings[index].card_data = value;

  return (dispatch) => {
    dispatch({
      type: "SET_CARD_SETIINGS_CARD_DATA",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setChartYaxisSettingsData = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  let arr = updateWidgetGraphConfig?.y_axis_settings?.map((el, i) => {
    return { ...el, show_as: value[i]?.chart_type };
  });
  updateWidgetGraphConfig.y_axis_settings = arr;

  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_SETIINGS_DATA",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setChartMedianAtYAxis = (value, obj, type) => {
  let updateWidgetGraphConfig = { ...obj };
  let arr = updateWidgetGraphConfig?.y_axis_settings?.map((el, i) => {
    return { ...el, median: value?.[i]?.median };
  });
  updateWidgetGraphConfig.y_axis_settings = [...arr];
  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_MEDIAN",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setChartMedianStaticAtYAxis = (value, obj, type) => {
  let updateWidgetGraphConfig = { ...obj };
  let arr = updateWidgetGraphConfig?.y_axis_settings?.map((el, i) => {
    return {
      ...el,
      is_median_static: value?.[i]?.is_median_static ?? false,
      // median: value?.[i]?.median ?? null,
    };
  });
  updateWidgetGraphConfig.y_axis_settings = [...arr];
  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_MEDIAN",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setLineProperty = (value, obj, listIndex) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.y_axis_settings[listIndex] = { ...value };
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_LINE_PROPERTY",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
export const setChartYaxisScale = (value, obj, type) => {
  let updateWidgetGraphConfig = { ...obj };
  if (type !== "combination") {
    updateWidgetGraphConfig.y_axis_settings[0].y_axis_scale = value;
  } else {
    let arr = updateWidgetGraphConfig?.y_axis_settings?.map((el, i) => {
      return { ...el, y_axis_scale: value[i]?.y_axis_scale };
    });
    updateWidgetGraphConfig.y_axis_settings = arr;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_SCALE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setChartYAxisMapAt = (value, obj, type) => {
  let updateWidgetGraphConfig = { ...obj };
  if (type !== "combination") {
    updateWidgetGraphConfig.y_axis_settings[0].y_axis_map_at = value;
  } else {
    let arr = updateWidgetGraphConfig?.y_axis_settings?.map((el, i) => {
      return { ...el, y_axis_map_at: value?.[i]?.y_axis_map_at };
    });
    updateWidgetGraphConfig.y_axis_settings = arr;
  }
  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_MAP_AT",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setChartYAxisMode = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_property.y_axis_mode = value;

  return (dispatch) => {
    dispatch({
      type: "SET_CHART_Y_AXIS_MODE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setChartEditField = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.edit_fields = value;

  return (dispatch) => {
    dispatch({
      type: "SET_CHART_EDIT_FIELDS",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setCustomAttributeName = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.custom_attribute.name = value;

  return (dispatch) => {
    dispatch({
      type: "SET_CUSTOM_ATTRIBUTE_NAME",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setPostCardOrderBy = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.order_by.offset = value;

  return (dispatch) => {
    dispatch({
      type: "SET_POST_CARD_ORDER_BY",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setPolificOrderByAttribute = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.order_by = value;

  return (dispatch) => {
    dispatch({
      type: "SET_POLIFIC_ORDER_BY_ATTRIBUTE",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setWidgetPreview = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_WIDGET_PREVIEW", payload: value });
  };
};

export const setWordcloudColour = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.wordcloud_color = value;
  return (dispatch) => {
    dispatch({
      type: "SET_WORDCLOUD_COLOUR",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setShowMinMaxDataGlobal = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_min_max_data = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SHOW_MIN_MAX_DATA",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setShowMaxDataGlobal = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_peak = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SHOW_PEAK",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setShowMinDataGlobal = (value, obj) => {
  let updateWidgetGraphConfig = { ...obj };
  updateWidgetGraphConfig.chart_settings.show_valley = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SHOW_VALLEY",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};

export const setGridConfig = (value) => {
  return (dispatch, getState) => {
    const updateWidgetGraphConfig = getState()?.GraphConfig?.widgetGraphConfig;
    updateWidgetGraphConfig.chart_settings.grid_config = value;
    dispatch({
      type: "SET_SHOW_VALLEY",
      widgetGraphConfig: updateWidgetGraphConfig,
    });
  };
};
